export const TaskAPI = {
  categories: openapiStrictFetch({
    url: 'v2/tasks/categories',
  }),
  savings: openapiStrictFetch({ url: 'v2/tasks/savings' }),
  createSaving: openapiStrictFetch({
    url: 'v2/tasks/savings',
    method: HTTPMethod.POST,
  }),
  updateSaving: openapiStrictFetch({
    url: 'v2/tasks/savings/{id}',
    method: HTTPMethod.PUT,
  }),
  deleteSaving: openapiStrictFetch({
    url: 'v2/tasks/savings/{id}',
    method: HTTPMethod.DELETE,
  }),
  random: openapiStrictFetch({
    url: 'v2/tasks/random',
  }),
  find: openapiStrictFetch({
    url: 'v2/tasks/{id}',
  }),
  similar: openapiStrictFetch({
    url: 'v2/tasks/{taskId}/similar',
  }),
  react: openapiStrictFetch({
    url: 'v2/tasks/{taskId}/react/{reaction}',
    method: HTTPMethod.POST,
  }),
};
